import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  Table,
  Tbody,
  Td,
  Tr,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import CrmDataService from "../../services/data";

export const TreatmentPlanModal = ({ isOpen, onClose, user, expert }: any) => {
  const [data, setData] = useState([]);
  const [expertId, setExpertId] = useState(expert || "");
  const [userEmail, setUserEmail] = useState(user || "");

//   console.log(expertId, userEmail, "expertId, userEmail");

  const getTreatmentPlan = () => {
    if (!expertId || !userEmail) {
      return;
    }
    CrmDataService.getTreatmentPlan(expertId, "", userEmail)
      .then((res) => {
        const planData = res?.data?.data?.map((item: any) => ({
          question: item.label,
          answer: item.values,
        }));

        setData(planData);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const handleClose = () => {
    setExpertId("");
    setUserEmail("");
    onClose();
  };

  useEffect(() => {
    getTreatmentPlan();
  }, [expertId, userEmail]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        size="3xl"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent borderRadius="lg" p={4}>
          <ModalHeader
            color="#16817A"
            fontWeight="extrabold"
            textAlign="center"
          >
            CLIENT TREATMENT PLAN
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            {" "}
            <Table variant="striped" size="md">
              <Tbody>
                {data.map((item: any, index: number) => (
                  <Tr key={index}>
                    <Td fontWeight="semibold" width="35%" fontSize="sm">
                      {item.question}
                    </Td>

                    <Td fontSize="sm">
                      {item.answer
                        ? item.answer
                            .split(",")
                            .map((ans: string, index: number) => (
                              <Text key={index}>{ans.trim()}</Text>
                            ))
                        : "—"}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </ModalBody>

          {/* <ModalFooter>
            <Button colorScheme="orange" onClick={onClose}>
              Close
            </Button>
          </ModalFooter> */}
        </ModalContent>
      </Modal>
    </>
  );
};
